import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut, PanelRightOpen, RefreshCw } from 'lucide-react';
import { useSaudiSidebarLayout } from '../context/SaudiSidebarLayoutContext';
import { useSaudiDateFilter } from '../context/SaudiDateFilterContext';
import { useSetup } from '../../../core/contexts/SetupContext';
import QawaemDateRangePresetsBar from '../components/QawaemDateRangePresetsBar';
import { isQawaemDirectAccess } from '../utils/isQawaemDirectAccess';

const HIDE_DATE_PATHS = new Set(['/settings', '/login', '/setup']);

function shouldShowDateBar(pathname) {
  if (HIDE_DATE_PATHS.has(pathname)) return false;
  if (pathname.includes('/config')) return false;
  return true;
}

export default function SaudiHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useSetup();
  const { open: sidebarOpen, toggle: toggleSidebar } = useSaudiSidebarLayout();
  const { preset, range, onPresetChange } = useSaudiDateFilter();

  const showDateBar = shouldShowDateBar(location.pathname);

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      /* ignore */
    }
    navigate(isQawaemDirectAccess() ? '/dashboard' : '/login', { replace: true });
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <header
      className="glass-header sticky top-0 z-[10000] shrink-0 px-4 py-2.5 sm:px-6 flex items-center justify-between gap-3"
      dir="rtl"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        {!sidebarOpen ? (
          <button
            type="button"
            onClick={toggleSidebar}
            className="btn-toolbar-refresh btn-header-compact shrink-0"
            title="إظهار القائمة"
            aria-label="إظهار القائمة"
          >
            <PanelRightOpen className="h-4 w-4" />
            <span className="hidden md:inline text-sm">القائمة</span>
          </button>
        ) : null}
        {showDateBar ? (
          <QawaemDateRangePresetsBar
            preset={preset}
            range={range}
            onPresetChange={onPresetChange}
            variant="header"
            className="console-header-date w-fit max-w-full min-w-0 shrink"
          />
        ) : null}
      </div>

      <div className="flex items-center shrink-0 gap-2">
        <button
          type="button"
          onClick={handleRefresh}
          className="btn-toolbar-refresh btn-header-compact shrink-0"
          title="تحديث الصفحة"
        >
          <RefreshCw className="h-4 w-4" />
          <span className="hidden md:inline text-sm">تحديث</span>
        </button>
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-2 px-3 py-2 rounded-xl glass-input text-forest-900 text-sm hover:bg-red-50 hover:border-red-200 btn-header-compact"
          title="تسجيل الخروج"
        >
          <LogOut size={18} />
          <span className="hidden sm:inline">خروج</span>
        </button>
      </div>
    </header>
  );
}
